import axios from '../lib/dm_axios';
import path from '../config/path';
const apiRootPath = path.apiRootPath;

var Controller = {};

Controller.getChallenges = async function() {
  try {
    var collectibles = await axios.get(apiRootPath + 'challenges');
    return collectibles;
  } catch (err) {
    console.log(err);
  }
};

Controller.getChallenge = async function(challengeId) {
  try {
    var collectibles = await axios.get(
      apiRootPath + `challenges/${challengeId}`
    );
    return collectibles;
  } catch (err) {
    console.log(err);
  }
};

export default Controller;
